import axios from 'axios'

/**
 * 查询首页项目的仪表盘数据
 * @param {*String} projectId 所属项目id
 */
export const dashboard = async (projectId) => {
  const { data: { detail } } = await axios.get(`v1/pgl/index/dashboard?projectId=${projectId}`)
  return detail
}

/**
 * 查询功率,发电量，放电量的图形列表数据
 * @param {*String} projectId 所属项目id
 * @param {*String} beginDate 开始时间，不填的系统默认当天的开始时间,格式yyyy-MM-dd
 * @param {*String} endDate 结束时间，不填的系统默认当天的结束时间,格式yyyy-MM-dd
 */
export const energyPowerChart = async (projectId, beginDate, endDate) => {
  const { data: { detail } } = await axios.get(`v1/pgl/index/energyPower?projectId=${projectId}&beginDate=${beginDate}&endDate=${endDate}`)
  return detail
}

/**
 * 查询首页差额图形柱形图列表数据，单位按天返回
 * @param {*String} projectId 所属项目id
 * @param {*String} beginDate 开始时间，不填的系统默认当天的开始时间,格式yyyy-MM-dd
 * @param {*String} endDate 结束时间，不填的系统默认当天的结束时间,格式yyyy-MM-dd
 */
export const balanceEnergy = async (projectId, beginDate, endDate) => {
  const { data: { detail } } = await axios.get(`v1/pgl/index/balanceEnergy?projectId=${projectId}&beginDate=${beginDate}&endDate=${endDate}`)
  return detail
}

/**
 * 用电放电排行榜
 * @param {*String} projectId 所属项目id
 */
export const rankingListIndex = async (projectId) => {
  const { data: { detail } } = await axios.get(`v1/pgl/index/ranking-list?projectId=${projectId}`)
  return detail
}

/**
 * 获取告警列表（分页）
 * @param {*String} projectId 所属项目id
 */
export const solarAlerts = async (projectId) => {
  const { data: { records } } = await axios.get(`v2/solar-alerts/pagi?projectId=${projectId}&pageNo=1&pageSize=10`)
  return records
}

/**
 * 设置充电/不充电
 * @param {*String} projectId 所属项目id
 * @param {*String} options.moteId 设备ID
 * @param {*type} options.type 1-充电/0-不充电
 */
export const putPowerSwitch = async (projectId, options) => {
  const { data } = await axios.put(`v1/solar-motes/putPowerSwitch?projectId=${projectId}`, {
    moteId: options.moteId,
    type: options.type
  })
  return data
}

/**
 * 监控中心-太阳能板统计
 * @param {*String} projectId 所属项目id
 * @param {*String} moteId 设备ID
 * @param {*type} date 时间，格式yyyy-MM-dd
 */
export const solarPvList = async (projectId, moteId, date) => {
  const { data } = await axios.get(`v1/pgl/index/solar-pv-list?projectId=${projectId}&moteId=${moteId}&date=${date}`)
  return data
}

/**
 * 监控中心-太阳能板统计-面板
 * @param {*String} projectId 所属项目id
 * @param {*String} moteId 设备ID
 * @param {*type} date 时间，格式yyyy-MM-dd
 */
export const solarPvPanel = async (projectId, moteId, date) => {
  const { data } = await axios.get(`v1/pgl/index/solar-pv-panel?projectId=${projectId}&moteId=${moteId}&date=${date}`)
  return data
}

/**
 * 监控中心-LED统计
 * @param {*String} projectId 所属项目id
 * @param {*String} moteId 设备ID
 * @param {*type} date 时间，格式yyyy-MM-dd
 */
export const LEDPvList = async (projectId, moteId, date) => {
  const { data } = await axios.get(`v1/pgl/index/solar-led-list?projectId=${projectId}&moteId=${moteId}&date=${date}`)
  return data
}

/**
 * 监控中心-LED统计-面板
 * @param {*String} projectId 所属项目id
 * @param {*String} moteId 设备ID
 * @param {*type} date 时间，格式yyyy-MM-dd
 */
export const LEDPvPanel = async (projectId, moteId, date) => {
  const { data } = await axios.get(`v1/pgl/index/solar-led-panel?projectId=${projectId}&moteId=${moteId}&date=${date}`)
  return data
}

/**
 * 监控中心-电池统计-面板
 * @param {*String} projectId 所属项目id
 * @param {*String} moteId 设备ID
 * @param {*type} date 时间，格式yyyy-MM-dd
 */
export const batteryPvList = async (projectId, moteId, date) => {
  const { data } = await axios.get(`v1/pgl/index/solar-battery-list?projectId=${projectId}&moteId=${moteId}&date=${date}`)
  return data
}
